module.exports = __webpack_public_path__ + "static/media/1.Angle Grinder.d346b831.jpg";